// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1ThCZ","content":"LoadingAlert_content__1Mqa4"};